import { Injectable } from '@angular/core';
import { CultureCodes, CurrencyCodes } from '../../../../Autofacets-Core/src/app/utils/enums';
import { SettingDataService } from '../data-services/setting-data.service';

/**
 * Secure Storage Helper service
 */
@Injectable({
  providedIn: 'root'
})

export class SettingService {
  currency: string;
  currencySymbol: string;
  onlyCountries:any;
  countryDialCodes:any;
  constructor(private settingDataService: SettingDataService) {
  }

  getCurrencyCode(cultureCode: string): string {
    let code = '';
    switch (cultureCode) {
      case CultureCodes.EN_US:
        code = CurrencyCodes.USD;
        break;
      case CultureCodes.NL_NL:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.NB_NO:
        code = CurrencyCodes.NOK;
        break;
      case CultureCodes.FI_FI:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.DE_DE:
        code = CurrencyCodes.EUR;
        break;
      default:
        code = CurrencyCodes.USD;
    }
    return code;
  }
  getCurrencySymbol(currencyCode: string): string {
    let code = '';
    switch (currencyCode) {
      case CurrencyCodes.USD:
        code = '$';
        break;
      case CurrencyCodes.EUR:
        code = '€';
        break;
      case CurrencyCodes.INR:
        code = '₹';
        break;
      case CurrencyCodes.NOK:
        code = 'kr';
        break;
      case CurrencyCodes.CAD:
        code = 'C$';
        break;
      case CurrencyCodes.GBP:
        code = '£';
        break;
      default:
        code = '$';
    }
    return code;
  }
  async GetSettings(): Promise<any> {
    return await this.settingDataService.GetSettings();
  }
  async getCountry(): Promise<any> {
    await this.settingDataService.getCountry().then((res) =>{
      if(res != null){
        let activeCountry = res.responseObject.filter(x=>x.isSmsAllowed == true);
        this.onlyCountries = activeCountry.map(country => country.code.toLowerCase())
        this.countryDialCodes = activeCountry.map(country => ({
          countryCode: country.code.toLowerCase(), 
          dialCode: country.mobileCode.replace('+', '')
        }));
      }
    });
  }
  async getBrandList(): Promise<any> {
    return this.settingDataService.getBrandList();
  }
  async getFieldConfiguration(screenName: string): Promise<any> {
    return this.settingDataService.getFieldConfiguration(screenName);
  }
}
